<script setup>
import { computed } from "vue";
import { n } from "components/jiffy/vue-cart/helpers/currency";

const props = defineProps({ totals: { type: Object, default: null } });
const totals = computed(() => props.totals);
</script>

<template>
  <div v-if="totals.grand" class="checkout-summary">
    <dl v-if="totals.createdProduct" class="checkout-summary__item">
      <dt class="checkout-summary__item-title">Created Product</dt>
      <dt class="checkout-summary__item-value">{{ n(totals.createdProduct, "currency") }}</dt>
    </dl>
    <dl v-if="totals.bulkDiscount" class="checkout-summary__item checkout-summary__item--discount">
      <dt class="checkout-summary__item-title">Bulk discount</dt>
      <dt class="checkout-summary__item-value">-{{ n(totals.bulkDiscount, "currency") }}</dt>
    </dl>
    <dl class="checkout-summary__item">
      <dt class="checkout-summary__item-title">Shipping</dt>
      <dt class="checkout-summary__item-value">
        <template v-if="totals.shipping">
          {{ n(totals.shipping, "currency") }}
        </template>
        <template v-else-if="totals.shipping === 0">FREE</template>
      </dt>
    </dl>
    <dl v-if="totals.assembly" class="checkout-summary__item">
      <dt class="checkout-summary__item-title">Assembly</dt>
      <dt class="checkout-summary__item-value">{{ n(totals.assembly, "currency") }}</dt>
    </dl>
    <dl v-if="totals.promotionTotal" class="checkout-summary__item">
      <dt class="checkout-summary__item-title">Promotion Total</dt>
      <dt class="checkout-summary__item-value">{{ n(totals.promotionTotal, "currency") }}</dt>
    </dl>
    <dl class="checkout-summary__item checkout-summary__item--large">
      <dt class="checkout-summary__item-title">Total</dt>
      <dt class="checkout-summary__item-value">{{ n(totals.grand, "currency") }}</dt>
    </dl>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/pod/settings";

.checkout-summary {
  padding: 18px 13px;
  border-radius: 6px;
  background: $pod-gray-modern-50;

  &__item {
    display: flex;
    justify-content: space-between;
    font-size: 14px;

    &--discount {
      color: $pod-danger;
    }

    &--large {
      font-size: 18px;
    }

    & + & {
      margin-top: 14px;
    }
  }

  &__item-value {
    font-weight: 600;
  }
}
</style>
